module.exports = __webpack_public_path__ + "static/img/institution06.eb4fa11.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/institution06.png
// module id = 20CO
// module chunks = 1